import { Route } from 'vue-router';

class RouterGuards {
  // eslint-disable-next-line
  async beforeEach(to: Route, from: Route, next: Function) {
    try {
      const isPrivate = to.matched.some(record => record.meta.isPrivate);

      if (isPrivate) {
        next({ name: 'page-401' });
      } else {
        next();
      }
    } catch (err) {
      next({ name: 'page-401' });
    }
  }
}

export default new RouterGuards();
